import dayjs from 'dayjs';

export const getTimezone = (date: Date) => {
  return date.toTimeString().split(' ')[1];
};

export const extractStartEndDates = (form: {
  scheduledDate: Date;
  startTime: Date;
  endTime: Date;
}) => {
  const dSchedDate = dayjs(form.scheduledDate);
  const dStartTime = dayjs(form.startTime);
  const dEndTime = dayjs(form.endTime);

  const year = dSchedDate.get('year');
  const month = dSchedDate.get('month');
  const date = dSchedDate.get('date');
  const startHour = dStartTime.get('hour');
  const startMin = dStartTime.get('minute');
  const endHour = dEndTime.get('hour');
  const endMin = dEndTime.get('minute');

  const startTime = new Date(year, month, date, startHour, startMin);
  const endTime = new Date(year, month, date, endHour, endMin);

  return {
    startTime,
    endTime,
  };
};
